module.exports = __webpack_public_path__ + "img/部分退货.f078aed7.svg";